import { PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Result } from '../../result/Result'

export type PageProps = PropsWithChildren<{
  // props here
}>

export const Page = (props: PageProps) => {
  const { children } = props;

  return (
    <ErrorBoundary fallback={<Result title={"Error"} message={"Something went wrong"} />}>
      {children}
    </ErrorBoundary>
  );
};
